import { Code, Shield, Cpu } from 'lucide-react';
import useRevealOnScroll from '../../hooks/use-reveal';

export default function About() {
    const aboutRef = useRevealOnScroll();

    return (
        <section
            id="about"
            className="min-h-screen flex justify-center items-center"
        >
            <div
                ref={aboutRef}
                className="reveal grid grid-cols-1 py-20 gap-x-5 gap-y-20 lg-hero:py-0 lg-hero:grid-cols-2 items-center"
            >
                <div className="about-intro">
                    <span className="child text-sm text-tint uppercase font-medium tracking-wide">
                        À propos de moi
                    </span>

                    <h1 className="child text-[clamp(20px,5vw,43px)] font-bold text-text mt-3 leading-tight max-w-[700px]">
                        Je suis{' '}
                        <span className="text-tint">Wilonjda Ebuela</span>,
                        développeur FullStack & passionné de cybersécurité
                    </h1>

                    <p className="child mt-5 text-[15px] text-muted leading-relaxed max-w-[550px]">
                        Je conçois des applications performantes, sécurisées et
                        orientées utilisateur. J’allie développement, sécurité
                        et intelligence artificielle pour créer des solutions
                        qui font vraiment la différence.
                    </p>

                    <div className="mt-6 flex flex-wrap gap-4">
                        <div className="child flex items-center gap-2 text-muted">
                            <Code className="text-tint" /> Développement Web
                        </div>
                        <div className="child flex items-center gap-2 text-muted">
                            <Shield className="text-tint" /> Cybersécurité
                        </div>
                        <div className="child flex items-center gap-2 text-muted">
                            <Cpu className="text-tint" /> Intelligence
                            Artificielle
                        </div>
                    </div>

                    <p className="child mt-4 text-[15px] text-muted leading-relaxed max-w-[550px]">
                        Quand je ne code pas, je m’intéresse à la veille tech et
                        à la découverte de nouvelles technologies qui
                        transforment notre manière de travailler.
                    </p>

                    <div className="child mt-8 flex flex-wrap gap-6">
                        <a
                            href="/cv"
                            className="py-3 px-[clamp(20px,5vw,35px)] text-md text-muted relative border border-border rounded-3xl bg-border hover:bg-transparent"
                        >
                            Voir mon CV →
                        </a>
                        <a
                            href="/files/wilondja_cv.pdf"
                            download="Wilondja_Ebuela_CV.pdf"
                            className="py-3 px-[clamp(20px,5vw,35px)] text-md text-muted border border-border rounded-3xl hover:bg-border transition"
                        >
                            Télecharger mon CV →
                        </a>
                    </div>
                </div>

                <div className="child about-visual relative flex items-center justify-center lg-hero:justify-end">
                    <img
                        src="images/luckson.jpg"
                        alt="Luckson"
                        className="border-4 border-tint rounded-3xl shadow-xl w-full max-w-[400px] object-cover"
                    />
                </div>
            </div>
        </section>
    );
}
